/**
 * @generated SignedSource<<3c36643e45d478fb287c27597e2550b9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Folder_folderPortfolioItems$data = ReadonlyArray<{
  readonly __typename: "PortfolioItemV2";
  readonly " $fragmentType": "Folder_folderPortfolioItems";
}>;
export type Folder_folderPortfolioItems$key = ReadonlyArray<{
  readonly " $data"?: Folder_folderPortfolioItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"Folder_folderPortfolioItems">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "Folder_folderPortfolioItems",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "PortfolioItemV2",
  "abstractKey": null
};

(node as any).hash = "da196c25d5f0eb1a44e37c24aca70d52";

export default node;
